import { createGenericContext } from "../../../utils/createGenericContext";
export const [SelectedUsersContext, useSelectedUsersContext] =
  createGenericContext([]);
